import {
    getTherapistRegistrationNotice as getSharedTherapistRegistrationNotice,
    resolveTherapistRegistrationNotice as resolveSharedTherapistRegistrationNotice,
    type TherapistRegistrationNoticeState,
} from "@mivo/ui/legalDocuments";
import { TRIAL_DAYS } from "@/domains/subscription/subscriptionConstants";
import type { SubscriptionPlanDefinition, SubscriptionPlanId } from "@/domains/subscription/plans";

export type { TherapistRegistrationNoticeState };

export function resolveTherapistRegistrationNotice(
    intendedPlanId: SubscriptionPlanId | null | undefined,
    catalog: readonly SubscriptionPlanDefinition[] | undefined,
    catalogReady: boolean,
    referral?: { active: true; planId: SubscriptionPlanId },
): TherapistRegistrationNoticeState {
    return resolveSharedTherapistRegistrationNotice(
        intendedPlanId,
        catalog,
        catalogReady,
        TRIAL_DAYS,
        referral,
    );
}

/** @deprecated Prefer resolveTherapistRegistrationNotice for loading/unavailable handling. */
export function getTherapistRegistrationNotice(
    intendedPlanId?: SubscriptionPlanId | null,
    catalog?: readonly SubscriptionPlanDefinition[],
    catalogReady = catalog != null,
): string {
    return getSharedTherapistRegistrationNotice(intendedPlanId, catalog, catalogReady, TRIAL_DAYS);
}

/** @deprecated Use resolveTherapistRegistrationNotice for plan-aware copy. */
export const THERAPIST_TRIAL_NOTICE = getTherapistRegistrationNotice();
